// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1iIeA","bigColWidth":"Table_bigColWidth__3aGmM","biggerColWidth":"Table_biggerColWidth__1SI_7","row":"Table_row__2cMXG","col":"Table_col__3v_GJ"};